<template>
  <div class="grid-whitepaper wrapper" :class="{ 'has-big': highlight }">
    <UiFilter v-if="tags" :content="tags" class="grid-whitepaper__filters" />

    <Common
      v-for="(item, index) in content.content"
      :key="index"
      :content="item"
      :class="{ 'is-big': highlight && index === 0 }"
    />

    <div v-if="content.content.length === 0" class="grid-whitepaper__message">
      {{ t('no-results') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import Common from '@/components/card/Common.vue'
import UiFilter from '@/components/ui/Filter.vue'

import type { PropType } from 'vue'
import type { WhitePaper } from '@/views/pages/WhitePaper.vue'

defineProps({
  content: {
    type: Object as PropType<WhitePaper['items']>,
    required: true,
  },
  tags: {
    type: Object as PropType<Record<string, string>>,
    required: false,
    default: undefined,
  },
  highlight: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const { t } = useI18n()
</script>

<style lang="scss" scoped>
$bp: 'l';

.grid-whitepaper {
  display: grid;
  gap: 4rem;
  margin-top: 4rem;
  margin-bottom: 8rem;

  .is-big {
    grid-row: 1/2;
    padding-bottom: 4rem;
    border-bottom: 0.1rem solid $c-grey-light;
  }

  @include mq($bp) {
    grid-template-columns: repeat(3, 1fr);

    .is-big {
      grid-column: span 3;
      padding-bottom: 8rem;
      border-bottom: 0.1rem solid $c-grey-light;
    }
  }
}

.grid-whitepaper__filters {
  .has-big & {
    margin-top: -2rem;
  }

  @include mq($bp) {
    grid-column: span 3;

    .has-big & {
      margin-top: -5rem;
    }
  }
}

.grid-whitepaper__message {
  grid-column: 1/4;
}
</style>
